import { useEffect, useState } from "react";
import "../../css/FormularioActor.css";
import { ListaUnidadesMedida } from "../../shared/UnidadesMedida";
import axios from "axios";
import { HEADERS_API } from "../NuevaGuia";
import { ValidarNum } from "../../shared/Regex";

export default function FormularioProductos({funcionAgregar, funcionCancelar}){

    //#region HOOKS STATE
    //Estados de lista de productos
    const[descProdAgregar, setDescProdAgregar] = useState("");
    const[codProdAgregar, setCodProdAgregar] = useState("");
    const[undProdAgregar, setUndProdAgregar] = useState("NIU");

    // Estados de validación
    const[datosCompletos, setDatosCompletos] = useState(true);
    //#endregion

    //#region HOOKS EFFECT
    useEffect(()=>{
        try {
            if(descProdAgregar == "" || codProdAgregar == "" || undProdAgregar == ""){
                throw new Error();
            }

            HandlerDatosCompletos(false);
        } catch (error) {
            HandlerDatosCompletos(true);
        }
    },[descProdAgregar, codProdAgregar, undProdAgregar]);
    //#endregion

    //#region HANDLERS
    // Estados de lista de productos

    const HandlerCodProdAgregar = (codigo) => {
        if(ValidarNum(codigo) || codigo == ""){
            setCodProdAgregar(codigo);
        }
    }

    const HandlerDescProdAgregar = (descripcion) => setDescProdAgregar(descripcion.toUpperCase());
    const HandlerUndProdAgregar = (codigo) => setUndProdAgregar(codigo);
    const HandlerDatosCompletos = (valor) => setDatosCompletos(valor);
    //#endregion

    //#region FUNCIONES
    
    //Funciones asíncronas
    async function insertarArticulo(){
        try{
            let response = await axios.post(URL_INSERTAR_ARTICULO,{
                codigoUsuario: "",
                descripcion: descProdAgregar,
                unidad: undProdAgregar,
                codigoArticulo: codProdAgregar
            },{
                headers: HEADERS_API
            }).catch(error => {
                throw new Error(error.message);
            });

            console.log(response.data);
        }catch(error){
            console.log(error);
        }
    }
    
    function ejecutarFuncion(){
        insertarArticulo();
        funcionAgregar(descProdAgregar, codProdAgregar, undProdAgregar);
        funcionCancelar();
    }

    return(<>
    <div id="modal-actor" className="d-flex justify-content-center align-items-center">
        <div id="formulario-registro">
            <div className="bg-primary text-white p-2 fs-4">
                NUEVO ARTÍCULO
            </div>
            <div className="p-2">
                <div className="row">
                    <div className="col-12 col-md-6 p-2">
                        <div className="form-floating">
                            <input onChange={e => HandlerCodProdAgregar(e.target.value)} value={codProdAgregar} maxLength={30} 
                            type="text" className="form-control" id="cod-producto" placeholder="Código" autoComplete="off"/>
                            <label htmlFor="cod-producto">Código</label>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 p-2">
                        <div className="form-floating">
                            <select value={undProdAgregar} onChange={e => HandlerUndProdAgregar(e.target.value)} id="und-producto" 
                            className="form-select" placeholder="Unidad de medida">
                                <ListaUnidadesMedida/>
                            </select>
                            <label htmlFor="und-producto">Unidad de medida</label>
                        </div>
                    </div>
                    <div className="col-12 p-2">
                        <div className="form-floating">
                            <input value={descProdAgregar} onChange={e => HandlerDescProdAgregar(e.target.value)} maxLength={120} id="desc-producto" 
                            type="text" className="form-control text-uppercase" autoComplete="off" placeholder="Descripción del producto"/>
                            <label htmlFor="desc-producto">Descripción del producto</label>
                        </div>
                    </div>
                    <div className="p-2 d-flex justify-content-around">
                        <button onClick={funcionCancelar} className="btn btn-secondary">Cancelar</button>
                        <button onClick={ejecutarFuncion} disabled={datosCompletos} className="btn btn-primary">Aceptar</button>
                    </div>
                </div>
            </div>
        </div>
    </div></>);
}

//#region CONSTANTES
const URL_INSERTAR_ARTICULO=process.env.REACT_APP_URL_INSERTAR_ARTICULO;